module.exports = __webpack_public_path__ + "static/media/fullstackdev.b7e98e7f.svg";